import { z } from 'zod';
import { PNL_SEGMENTS, PNL_SOURCES } from '../../config.ts';
import { day, instant } from './primitives.ts';

/** The longest window Console will share. */
const VERIFIED_PNL_MAX_DAYS = 360;

const pnlSegmentSchema = z.enum(PNL_SEGMENTS);

const pnlSourceSchema = z.enum(PNL_SOURCES);

export type PnlSegment = z.infer<typeof pnlSegmentSchema>;

/**
 * The days the verified link stated, and the account value the desk read after each close; a
 * missing day is not stated, not zero. Null is unknown and shows as a dash, not zero.
 */
const dayPnlSchema = z.object({
  day,
  fno: z.number().nullable(),
  commodity: z.number().nullable(),
  charges: z.number().nullable(),
  accountValue: z.number().nullable(),
  source: pnlSourceSchema,
  capturedAt: instant,
});

export type DayPnl = z.infer<typeof dayPnlSchema>;

/** The report hash is never sent back to the browser. */
const verifiedLinkSchema = z.object({
  shared: z.boolean(),
  from: day.nullable(),
  to: day.nullable(),
  segments: z.array(pnlSegmentSchema),
  live: z.boolean().nullable(),
  syncedAt: instant.nullable(),
  waitMs: z.number().int(),
});

export type VerifiedLink = z.infer<typeof verifiedLinkSchema>;

export const VERIFIED_PNL_REACH_DAYS = VERIFIED_PNL_MAX_DAYS;

export const pnlLedgerSchema = z.object({
  linked: z.boolean(),
  from: day,
  today: day,
  rows: z.array(dayPnlSchema),
  verified: verifiedLinkSchema,
});

export type PnlLedger = z.infer<typeof pnlLedgerSchema>;
